import { render, staticRenderFns } from "./BudgetComponent.vue?vue&type=template&id=53387106&"
import script from "./BudgetComponent.vue?vue&type=script&lang=js&"
export * from "./BudgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./BudgetComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports